/* Krishna Furniture — grand-opening sale, in 3D.
   Loads kf-sale.glb (two scenes, every piece a separate node) onto a transparent full-screen
   canvas, so the site stays visible behind it. Pieces fly in one by one, the whole set turns
   slowly and leans toward the pointer, gold and red confetti falls through it in 3D, and after
   `switchAfter` seconds the first scene breaks apart and the offer assembles in its place.

   Needs THREE (r128) and THREE.GLTFLoader on the page; THREE.MeshoptDecoder is used when present.
   window.KFSale3D(opts) -> controller | null
     opts: canvas, url, reduce (bool), autostart (default true; false = load and wait for start()), onReady(), onError(err)
   controller: start(), show(i), leave(cb), hit(x, y), destroy(), scene index via .current
*/
(function () {
  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function easeOutBack(t) { var c1 = 1.5, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); }
  function easeInCubic(t) { return t * t * t; }

  window.KFSale3D = function (opts) {
    if (typeof THREE === 'undefined' || !THREE.GLTFLoader) return null;
    var canvas = opts.canvas, reduce = !!opts.reduce;
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    } catch (e) { return null; }
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.75));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.0;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);

    /* A studio in a texture: two bright softboxes and a warm floor bounce. Gold only reads as
       gold when it has something bright to reflect. */
    (function () {
      var c = document.createElement('canvas'); c.width = 512; c.height = 256;
      var x = c.getContext('2d');
      var g = x.createLinearGradient(0, 0, 0, 256);
      g.addColorStop(0, '#fff8ec'); g.addColorStop(.35, '#e9d2ae'); g.addColorStop(.55, '#7a5d3e'); g.addColorStop(1, '#1a120b');
      x.fillStyle = g; x.fillRect(0, 0, 512, 256);
      function box(cx, cy, rx, ry, a) {
        var r = x.createRadialGradient(cx, cy, 0, cx, cy, Math.max(rx, ry));
        r.addColorStop(0, 'rgba(255,252,240,' + a + ')'); r.addColorStop(1, 'rgba(255,252,240,0)');
        x.fillStyle = r; x.beginPath(); x.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); x.fill();
      }
      box(130, 50, 90, 46, 1); box(380, 60, 70, 40, .9); box(256, 30, 120, 22, .7); box(256, 240, 260, 30, .35);
      var tex = new THREE.CanvasTexture(c); tex.mapping = THREE.EquirectangularReflectionMapping;
      var pm = new THREE.PMREMGenerator(renderer);
      scene.environment = pm.fromEquirectangular(tex).texture; pm.dispose();
    })();
    scene.add(new THREE.HemisphereLight(0xfff4e0, 0x3a2414, .55));
    var key = new THREE.DirectionalLight(0xfff1dc, 1.6); key.position.set(3, 6, 7); scene.add(key);
    var rim = new THREE.DirectionalLight(0xffd29a, 1.1); rim.position.set(-5, 3, -4); scene.add(rim);
    var fill = new THREE.DirectionalLight(0xffffff, .35); fill.position.set(-4, -1, 6); scene.add(fill);

    var stage = new THREE.Group(); scene.add(stage);
    var sets = [], current = 0, phase = [], destroyed = false, raf = 0, t0 = performance.now();
    var pointer = { x: 0, y: 0, tx: 0, ty: 0 };

    /* ---- confetti: one instanced mesh, three colours ---- */
    var CONF = reduce ? 0 : 150, conf = null, cData = [];
    if (CONF) {
      var cg = new THREE.PlaneGeometry(.07, .12);
      var cm = new THREE.MeshStandardMaterial({ side: THREE.DoubleSide, metalness: .55, roughness: .35 });
      conf = new THREE.InstancedMesh(cg, cm, CONF);
      var palette = [new THREE.Color(0xf3c24f), new THREE.Color(0xf3c24f), new THREE.Color(0xd3122a), new THREE.Color(0xfbf0dc)];
      for (var i = 0; i < CONF; i++) {
        cData.push({ x: (Math.random() - .5) * 9, y: Math.random() * 8 - 3, z: (Math.random() - .5) * 4 - .5,
          vy: .35 + Math.random() * .55, sw: Math.random() * 6.28, rx: Math.random() * 6.28, ry: Math.random() * 6.28, vr: 1 + Math.random() * 3 });
        conf.setColorAt(i, palette[i % palette.length]);
      }
      conf.instanceColor.needsUpdate = true;
      scene.add(conf);
    }
    var dummy = new THREE.Object3D();

    function frame(w, h) {
      // fit the art into roughly the middle two-thirds of the window, whatever its shape, so the
      // site still shows round it (a 7.6 x 6.6 box: the scene is about 5 x 4.6)
      var fov = camera.fov * Math.PI / 180, aspect = w / h;
      var bw = aspect < .8 ? 5.9 : 7.6;   // on a phone held upright the art can use more of the width
      var dist = Math.max((6.6 / 2) / Math.tan(fov / 2), (bw / 2) / (Math.tan(fov / 2) * aspect));
      camera.position.set(0, .35, dist); camera.lookAt(0, .05, 0);
    }
    function resize() {
      var w = canvas.clientWidth || window.innerWidth, h = canvas.clientHeight || window.innerHeight;
      renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); frame(w, h);
    }
    window.addEventListener('resize', resize);
    function onMove(e) {
      var p = e.touches ? e.touches[0] : e; if (!p) return;
      pointer.tx = clamp(p.clientX / window.innerWidth - .5, -.5, .5);
      pointer.ty = clamp(p.clientY / window.innerHeight - .5, -.5, .5);
    }
    window.addEventListener('pointermove', onMove, { passive: true });

    /* ---- per-piece choreography ----
       Every piece arrives from its own random direction, turning as it comes, fades up as it
       lands, and leaves the same way toward another random side. Lettering only sways once it
       is in place (so it stays readable); furniture, the crown and the gold swirls keep turning. */
    var READ = { Grand: 1, OpeningWord: 1, Ribbon: 1, Plaque: 1, Banner: 1, Pct: 1, FlatOff: 1, DaysRibbon: 1, Tag: 1, Podium: 1, Podium2: 1 };
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function randDir() { var a = Math.random() * Math.PI * 2; return new THREE.Vector3(Math.cos(a), Math.sin(a) * .8, 0); }
    function prepare(set) {
      set.items = set.node.children.map(function (n, k) {
        var base = { p: n.position.clone(), r: n.rotation.clone(), s: n.scale.clone() };
        // each piece gets its own copies of its materials, so it can fade on its own
        var mats = [];
        n.traverse(function (o) {
          if (!o.isMesh) return;
          o.material = Array.isArray(o.material) ? o.material.map(function (m) { var c = m.clone(); mats.push(c); return c; })
                                                 : (function (m) { var c = m.clone(); mats.push(c); return c; })(o.material);
        });
        return { n: n, base: base, k: k, mats: mats, state: 'hidden', read: !!READ[n.name], turn: rnd(.25, .6) * (Math.random() < .5 ? -1 : 1) };
      });
      set.node.visible = false;
    }
    function fade(it, a) {
      it.mats.forEach(function (m) { m.transparent = a < .999; m.opacity = a; m.depthWrite = a > .5; });
    }
    function enter(set, now) {
      set.node.visible = true;
      set.items.forEach(function (it, i) {
        it.state = 'in'; it.start = now + (reduce ? 0 : rnd(0, 520) + i * 40); it.dur = reduce ? 1 : rnd(900, 1300);
        it.dir = randDir(); it.dist = rnd(4.5, 7); it.dz = rnd(-2, 4);
        it.spin = new THREE.Vector3(rnd(-1, 1) * Math.PI, (Math.random() < .5 ? -1 : 1) * rnd(1, 2) * Math.PI * 2, rnd(-1, 1) * Math.PI * .5);
        fade(it, 0);
      });
    }
    function leave(set, now) {
      set.items.forEach(function (it, i) {
        it.state = 'out'; it.start = now + (reduce ? 0 : rnd(0, 380)); it.dur = reduce ? 1 : rnd(800, 1150);
        it.dir = randDir(); it.dist = rnd(5, 8); it.dz = rnd(-2, 3);
        it.spin = new THREE.Vector3(rnd(-1, 1) * Math.PI, (Math.random() < .5 ? -1 : 1) * rnd(1, 2) * Math.PI * 2, rnd(-1, 1) * Math.PI * .6);
        it.from = { p: it.n.position.clone(), r: it.n.rotation.clone() };
      });
    }
    function apply(it, now, time) {
      var n = it.n, b = it.base, t;
      if (it.state === 'in') {
        t = clamp((now - it.start) / it.dur, 0, 1);
        var e = easeOutBack(t), u = 1 - t * t * (3 - 2 * t);   // u: 1 -> 0, smooth
        n.position.set(b.p.x + it.dir.x * it.dist * u, b.p.y + it.dir.y * it.dist * u, b.p.z + it.dz * u);
        n.rotation.set(b.r.x + it.spin.x * u, b.r.y + it.spin.y * u, b.r.z + it.spin.z * u);
        var s = Math.max(.001, lerp(.15, 1, e));
        n.scale.set(b.s.x * s, b.s.y * s, b.s.z * s);
        fade(it, clamp(t * 1.8, 0, 1));
        if (t >= 1) { it.state = 'idle'; it.idle0 = time; fade(it, 1); }
      } else if (it.state === 'idle') {
        var tt = time - (it.idle0 || 0);
        n.position.set(b.p.x, b.p.y + Math.sin(time * 1.4 + it.k * .9) * .035, b.p.z + Math.sin(time * .9 + it.k) * .03);
        if (it.read) n.rotation.set(b.r.x, b.r.y + Math.sin(time * .8 + it.k * 1.3) * .07, b.r.z);
        else n.rotation.set(b.r.x, b.r.y + tt * it.turn, b.r.z);   // keeps turning, slowly
        n.scale.copy(b.s);
      } else if (it.state === 'out') {
        t = clamp((now - it.start) / it.dur, 0, 1); var o = easeInCubic(t);
        var f = it.from || b;
        n.position.set(f.p.x + it.dir.x * it.dist * o, f.p.y + it.dir.y * it.dist * o, f.p.z + it.dz * o);
        n.rotation.set(f.r.x + it.spin.x * o, f.r.y + it.spin.y * o, f.r.z + it.spin.z * o);
        var so = Math.max(.001, 1 - o * .6); n.scale.set(b.s.x * so, b.s.y * so, b.s.z * so);
        fade(it, 1 - clamp(t * 1.25, 0, 1));
        if (t >= 1) it.state = 'hidden';
      }
    }

    function loop(now) {
      if (destroyed) return;
      raf = requestAnimationFrame(loop);
      var time = (now - t0) / 1000;
      pointer.x = lerp(pointer.x, pointer.tx, .06); pointer.y = lerp(pointer.y, pointer.ty, .06);
      if (!reduce) {
        stage.rotation.y = Math.sin(time * .42) * .34 + pointer.x * .55;
        stage.rotation.x = .06 + Math.sin(time * .31) * .035 + pointer.y * .22;
      }
      sets.forEach(function (set) {
        var any = false;
        set.items.forEach(function (it) { if (it.state !== 'hidden') { apply(it, now, time); any = true; } });
        if (!any) set.node.visible = false;
      });
      if (conf) {
        for (var i = 0; i < CONF; i++) {
          var d = cData[i];
          d.y -= d.vy * .016; if (d.y < -3.4) { d.y = 4.6; d.x = (Math.random() - .5) * 9; }
          d.rx += d.vr * .016; d.ry += d.vr * .011;
          dummy.position.set(d.x + Math.sin(time * 1.2 + d.sw) * .25, d.y, d.z);
          dummy.rotation.set(d.rx, d.ry, 0); dummy.updateMatrix(); conf.setMatrixAt(i, dummy.matrix);
        }
        conf.instanceMatrix.needsUpdate = true;
      }
      renderer.render(scene, camera);
    }

    var loader = new THREE.GLTFLoader();
    var mo = window.MeshoptDecoder || THREE.MeshoptDecoder;
    if (mo && loader.setMeshoptDecoder) loader.setMeshoptDecoder(mo);
    loader.load(opts.url, function (gltf) {
      if (destroyed) return;
      var root = gltf.scene.getObjectByName('KFSale') || gltf.scene;
      ['Opening', 'Offer'].forEach(function (name) {
        var node = root.getObjectByName(name); if (!node) return;
        var set = { node: node }; prepare(set); sets.push(set);
      });
      // the shine is set here rather than in the file: it depends on this page's light
      root.traverse(function (o) {
        if (!o.isMesh) return;
        var ms = Array.isArray(o.material) ? o.material : [o.material];
        ms.forEach(function (m) { m.envMapIntensity = m.metalness > .5 ? 1.35 : .7; });
      });
      stage.add(gltf.scene);
      resize();
      if (opts.autostart === false) {
        // Built ahead of time: compile every material's shader now (pieces briefly visible for it),
        // so start() later has nothing heavy left to do and the art appears on the spot.
        sets.forEach(function (st) { st.node.visible = true; });
        try { renderer.compile(scene, camera); } catch (e) {}
        sets.forEach(function (st) { st.node.visible = false; });
      } else start();
      opts.onReady && opts.onReady();
    }, undefined, function (err) { opts.onError && opts.onError(err); });

    // picking: a click that lands on a piece of the art follows the link; anywhere else does not
    var ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
    function pick(x, y) {
      var r = canvas.getBoundingClientRect();
      ndc.set(((x - r.left) / r.width) * 2 - 1, -((y - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(ndc, camera);
      var set = sets[current]; if (!set) return false;
      return ray.intersectObject(set.node, true).length > 0;
    }

    var started = false;
    function start() {
      if (started || destroyed || !sets.length) return;
      started = true; t0 = performance.now();
      enter(sets[0], t0);
      raf = requestAnimationFrame(loop);
    }

    var api = {
      get current() { return current; },
      start: start,
      show: function (i) {
        if (!sets[i] || i === current) return;
        var now = performance.now();
        leave(sets[current], now); current = i;
        enter(sets[i], now + (reduce ? 0 : 380));
      },
      hit: pick,
      // every piece of the scene on screen leaves toward a random side; cb when they are gone
      leave: function (cb) {
        var set = sets[current]; if (!set) return cb && cb();
        leave(set, performance.now()); setTimeout(function () { cb && cb(); }, reduce ? 50 : 1500);
      },
      destroy: function () {
        destroyed = true; cancelAnimationFrame(raf);
        window.removeEventListener('resize', resize); window.removeEventListener('pointermove', onMove);
        try { renderer.dispose(); renderer.forceContextLoss(); } catch (e) {}
      }
    };
    resize();
    return api;
  };
})();
